import axios from 'axios';
import { StashCategory } from '@stash/shared-types';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export async function getTopLevelCategories(): Promise<StashCategory[]> {
  const response = await axios.get<{ data: StashCategory[] }>(`${BASE_URL}/top-level-categories`);
  return response.data.data;
}
